import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPutAwayCandidates, movePutAway, resolvePutAwayTarget, searchPutAwayLocations, validatePutAwayLocation } from '../../redux/putaway';
export var usePutAwayQueue = function () {
    var dispatch = useDispatch();
    var isLoading = useSelector(function (state) { return state.putaway.isLoading; });
    var fetchCandidates = useCallback(function () { return dispatch(fetchPutAwayCandidates()).unwrap(); }, [dispatch]);
    var resolveTarget = useCallback(function (scanId) {
        var barcode = (scanId || '').trim();
        if (!barcode)
            return Promise.resolve({ error: 'Scan or enter a container or receiving tag' });
        return dispatch(resolvePutAwayTarget({ scanId: barcode })).unwrap();
    }, [dispatch]);
    // Free-type/scan search of storage locations (Bulk/Pick). Never receiving.
    var searchLocations = useCallback(function (term, types) {
        return dispatch(searchPutAwayLocations({ term: term, types: types })).unwrap();
    }, [dispatch]);
    // Resolve a typed/scanned location to its canonical seqId, rejecting receiving/cart/pack.
    var validateLocation = useCallback(function (rawLocation) {
        var scanId = (rawLocation || '').trim();
        if (!scanId)
            return Promise.resolve({ ok: false, error: 'Enter a location' });
        return dispatch(validatePutAwayLocation({ rawLocation: scanId })).unwrap();
    }, [dispatch]);
    var move = useCallback(function (args) { return dispatch(movePutAway(args)).unwrap(); }, [dispatch]);
    return {
        isLoading: isLoading,
        fetchCandidates: fetchCandidates,
        resolveTarget: resolveTarget,
        searchLocations: searchLocations,
        validateLocation: validateLocation,
        move: move
    };
};
export default usePutAwayQueue;
